import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackQuickOrderListItemsUploadedParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackQuickOrderListItemsUploaded";

const useTrackQuickOrderListItemsUploaded = (
    parameters: TrackQuickOrderListItemsUploadedParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.quickOrderListItemsUploaded, parameters, options);
};

export default useTrackQuickOrderListItemsUploaded;
